import { memo } from "react";

import { useEditor } from "../EditorContext"
import GroupForm from "./GroupForm";

import HorizontalLayout from "../LayoutEditor/HorizontalLayout";
import VerticalLayout from "../LayoutEditor/VerticalLayOut";
import Label from "../LayoutEditor/Label";
import ConfirmationModal from "../../../common/ConfirmationModal";


// чтобы заработала мемоизация нужно, чтобы при каждом обновлении формы не менялись пропсы и контекст у всех групп
const Group = memo(function Group ({group, formStructure}) { //, removeElement, createLayout, createField}) {
  
  const {removeElement, createLayout, createLabel, updateLabel, editingElement, setEditingElement} = useEditor()
  const isEditing = editingElement === group.id

  let rows = [];
  for(let i in group.elements) {
    if (group.elements[i].type == 'HorizontalLayout') {
      //console.log(group.id)
      rows.push(
        <HorizontalLayout
          key={group.elements[i].id}
          groupId={group.id}
          layout={group.elements[i]}
          formStructure={formStructure}
          //removeElement={removeElement}
          //createField={createField}
        />
      );
    }
    if (group.elements[i].type == 'VerticalLayout') {
      rows.push(
        <VerticalLayout
          key={group.elements[i].id} 
          layout={group.elements[i]}
          formStructure={formStructure}
          //removeElement={removeElement}
          //createField={createField}
        />
      );
    }
    if (group.elements[i].type == 'Label') {
      rows.push(
        <Label
          key={group.elements[i].id}
          groupId={group.id} 
          label={group.elements[i]}
          formStructure={formStructure}
          //removeElement={removeElement}
        />
      );
    }

  }

  let modalId = 'confirmGroupDeleteModal_' + group.id

  return (
    <div className="card mx-0 my-5 p-4 bg-light-subtle">

      <ConfirmationModal
        modalId={modalId}
        headerText="Группа макетов"
        messageText={[
          "Вы уверены, что хотите удалить группу макетов?"
        ]}
        confirmButtonText="Удалить" 
        Action={() => removeElement(formStructure, group.id)}
        danger
      />

      <div className="card-body">
        <div className=''>
          <div className="dropdown mb-3">

            <button className="btn editor-button m-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" className="bi bi-menu-button-wide" viewBox="0 0 16 16">
                <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v2A1.5 1.5 0 0 1 14.5 5h-13A1.5 1.5 0 0 1 0 3.5zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z"/>
                <path d="M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m10.823.323-.396-.396A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0M0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"/>
              </svg>
            </button>
            <ul className="dropdown-menu">
              {isEditing ?
                <>
                  <button className="dropdown-item" type="button" disabled onClick={() => setEditingElement(undefined)}>редактировать</button>
                </>
              :
                <>
                  <button className="dropdown-item" type="button" onClick={() => setEditingElement(group.id)}>редактировать</button>
                </>
              }
              <button className="dropdown-item lk-menu-dropdown" disabled>переместить вверх</button>
              <button className="dropdown-item lk-menu-dropdown" disabled>переместить вниз</button>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item lk-menu-dropdown" data-bs-toggle="modal" data-bs-target={'#' + modalId}>удалить группу макетов</button> 
            </ul>


          </div>
        </div>
        <h1>
          {group.label}

        </h1>
        {isEditing ?
          <GroupForm
            group={group}
            formStructure={formStructure}
          />
        :
          <></>
        }



        <div className="row mt-5 ms-3">
          <div>
            <button 
              className="btn editor-button m-0 me-2" 
              onClick={() => createLayout(formStructure, group.id)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" fill="currentColor" className="bi bi-plus-square" viewBox="0 0 16 16">
                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
              </svg>
            </button>
            добавить горизонтальный макет
          </div>
        </div>
        <div className="row mb-5 ms-3">
          <div>      
            <button 
                className="btn editor-button m-0 mt-2 me-2" 
                onClick={() => createLabel(formStructure, group.id)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" fill="rgb(47,82,160)" className="bi bi-plus-square" viewBox="0 0 16 16">
                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
              </svg>
            </button>
            добавить текстовый блок
          </div>  
        </div>  
        {rows}
      </div>  
    </div>
  )
})

export default Group